import {combine, merge, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';
import {initFiltersTable, initSortingsTable} from 'core/hooks/grid2.0';
import {profile$} from 'models/auth';
import {mapFilters, mapSortings} from 'utils/grid-mappers';

import {OrdersCreateGate} from '../../orders/create';

import {BillingInvoicesGate} from '../billingIvoice';

import {
    balance$,
    BillingGate,
    billingList$,
    defaultFilters,
    defaultSortings,
    filters$,
    filtersChanged,
    filtersReset,
    loadBalanceDataFx,
    loadBillingDataFx,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    sortings$,
    sortingsChanged,
    sortingsReset,
    stateReset,
    tableStateChanged,
    updateBalance,
} from './index';

billingList$.on(loadBillingDataFx.done, (_, {result}) => result).reset(BillingGate.close);
balance$.on(loadBalanceDataFx.done, (_, {result}) => result);

initFiltersTable(filters$, filtersChanged, filtersReset, defaultFilters, stateReset);
initSortingsTable(sortings$, sortingsChanged, sortingsReset, defaultSortings, stateReset);

sample({
    clock: merge([BillingGate.open, pageNumberChanged, pageSizeChanged, tableStateChanged]),
    source: combine({
        sortings: sortings$,
        pageNumber: pageNumber$,
        pageSize: pageSize$,
        filters: filters$,
        legalIdentityId: profile$.map((params) => params?.client?.legalIdentityId),
    }),
    fn: ({pageNumber, pageSize, filters, sortings, legalIdentityId}) => ({
        paging: {
            pageNumber,
            pageSize,
        },
        filters: mapFilters(filters),
        sortings: mapSortings(sortings),
        legalIdentityId,
    }),
    target: loadBillingDataFx,
});

sample({
    clock: merge([
        BillingGate.open,
        BillingInvoicesGate.open,
        OrdersCreateGate.open,
        updateBalance,
    ]),
    source: {id: profile$.map((params) => params?.client?.legalIdentityId)},
    fn: ({id}) => id,
    target: loadBalanceDataFx,
});

loadBillingDataFx.failData.watch((err) => showRestError(err as RestError));
